import { useMemo } from "react";
import { useTime } from "../../../Hooks/useTime";
import { DateTime, Duration } from "luxon";
import { ITimeEntry } from "../../../Data/Models/ITimeEntry";
import { useTimeEntries } from "../../../Hooks/useTimeEntries";
import { formatDurationElements } from "./useGroupTime";
import { usePlayingTime } from "../Playhead/usePlayingTime";

export function useCompressedTimeEntryTime(compressedTimeEntry: ITimeEntry[], source: string) {
	const time = useTime();
	const { isPlaying } = usePlayingTime() || {};
	const timeEntries = useTimeEntries(source);
	return useMemo(() => {
		const timeInSeconds = compressedTimeEntry.reduce(
			(acc, curr) => acc.plus((curr.endedWhen || DateTime.local()).diff(curr.startedWhen, "seconds")),
			Duration.fromMillis(0)
		);
		return formatDurationElements(timeInSeconds);
	}, [isPlaying, isPlaying ? time : undefined, timeEntries.timestamp]);
}
